import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getVerifyPanUrl } from "../utils/urlHelper";

const verifyPanCardApi = createApi({
  reducerPath: "verifyPan",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    verifyPan: builder.mutation({
      query: (body) => ({
        url: getVerifyPanUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useVerifyPanMutation } = verifyPanCardApi;
export { verifyPanCardApi };
